<aig-modal class="aig-modal-rejected" position="center" customMaxWidth="600px">
  <div class="u-p-8 u-pb-3" body>
    <div class="p-flexcc u-dir-col">
      <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
      @if (existenSiniestros) {
      <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">
        Debido al estado de tu póliza no puedes abrir un nuevo siniestro. Por
        favor, revisa el estado de tu póliza. Recuerda que para cualquier
        consulta puedes escribirnos a
        <a href="mailto:backoffice.caixa@icp.es" class="u-color-selected1">
          {{ supportEmail }}
        </a>
      </p>
      } @else {
      <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">
        La póliza no tiene siniestros asociados. Debido al estado actual de la
        misma, no puedes abrir un nuevo siniestro. Recuerda que para cualquier
        consulta puedes escribirnos a
        <a href="mailto:backoffice.caixa@icp.es" class="u-color-selected1">
          {{ supportEmail }}
        </a>
      </p>

      }
    </div>
  </div>
  <div class="u-p-8 u-pt-def" buttons>
    <button
      class="e-btn--primary p-flexcc u-size-per-100"
      (click)="clickHide()"
    >
      <p class="u-fs-16 u-fw-600">Aceptar</p>
    </button>
  </div>
</aig-modal>
